// Browser-native UTF-8 conversion; no Node Buffer polyfill in the client bundle.
export const encodeBase64 = (value) =>
  btoa(
    Array.from(new TextEncoder().encode(value), (byte) =>
      String.fromCharCode(byte)
    ).join('')
  );

export const decodeBase64Url = (value) => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const bytes = Uint8Array.from(atob(base64), (character) =>
    character.charCodeAt(0)
  );
  return new TextDecoder().decode(bytes);
};
